// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/assets/img/website/bg-curve-line.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../public/assets/img/website/pattern-1.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../public/assets/img/website/pattern-2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../public/assets/img/website/left-quote.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../../public/assets/img/website/right-quote.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-gradient {
  background: linear-gradient(90deg, var(--primary-color) 0%, var(--primary-color) 25%, var(--secondary-color) 100%);
  border-radius: 0 0 250px 0;
}

.landing-page {
  background-color: var(--bg-white);
}

.carousel-section {
  padding: 176px 70px 0px 100px;
}

.section-content {
  padding: 100px 0px 0 0px;
}

.carousel-section h2 {
  font-size: var(--font-size-xxxxlarge);
  font-weight: var(--font-bold);
  color: var(--text-white);
  margin-bottom: 30px;
  font-family: var(--font-codec-cold);
}

.carousel-section p {
  font-size: var(--font-size-large);
  font-weight: var(--font-medium);
  color: var(--text-white);
  margin-bottom: 30px;
}

.carousel-section p span {
  color: var(--secondary-color);
  font-style: italic;
}

.header-image-anim {
  position: absolute;
  bottom: 0;
  right: 250px;
}

.header-image-anim img {
  width: 600px;
}

/* Carousel Styles */
.carousel-container {
  position: relative;
  transition: opacity 0.5s ease-in-out;
}

.carousel-container.fade-in {
  opacity: 1;
}

.carousel-container.fade-out {
  opacity: 0;
}

.carousel-image {
  width: 600px;
  display: block;
}

/* Carousel Indicators */
.carousel-indicators {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 20px;
}

.indicator {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: all 0.3s ease;
}

.indicator:hover {
  background-color: rgba(255, 255, 255, 0.8);
  transform: scale(1.2);
}

.indicator.active {
  background-color: var(--secondary-color);
  transform: scale(1.2);
}

.sparkle-image {
  position: absolute;
  right: 150px;
  top: 200px
}

.process-steps-container {
  padding: 0px 0 0 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 50%;
  background-position: center 20px;
  background-repeat: no-repeat;
}

.step-image {
  text-align: center;
  margin-bottom: 20px;
}

.step-image img {
  max-width: 275px;
}

.step-info .step-number {
  font-size: var(--font-size-xlarge);
  font-weight: var(--font-bold);
  color: var(--text-black);
  margin-bottom: 10px;
}

.step-image {
  min-height: 245px;
  display: flex;
  justify-content: center;
  align-items: end;
}

.step-info h4 {
  font-size: var(--font-size-xlarge);
  font-weight: var(--font-bold);
  color: var(--text-primary);
  font-family: var(--font-codec-cold);
  margin-top: 10px;
}

.step-info p {
  font-size: var(--font-size-medium);
  font-weight: var(--font-medium);
  color: var(--text-black);
  margin-top: 15px;
}

.step-info {
  padding: 0 50px;
}

/* Info Cards Styles */

.info-card {
  background: #FFFFFF;
  padding: 30px 75px 15px 75px;
  text-align: center;
  height: 100%;
  position: relative;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  border-radius: 50px 8px 50px 8px;
  border: 2px solid transparent;
  background-clip: padding-box;
  isolation: isolate;
}

.info-card::before {
  content: '';
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  border-radius: 50px 8px 50px 8px;
  background: linear-gradient(135deg, #FFD700 0%, #FFD700 25%, #8B5CF6 75%, #8B5CF6 100%);
  z-index: -1;
  pointer-events: none;
}

.info-card::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 50px 8px 50px 8px;
  background: #FFFFFF;
  z-index: -1;
  pointer-events: none;
}

.info-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
}

.slide-card-carousel {
  border-radius: 6px 46px 6px 46px;
}

.slide-card-carousel video {
  border-radius: 6px 46px 6px 46px;
}

.slide-card-carousel .video-wrapper {
  padding: 2px;
  /* border thickness */
  border-radius: 6px 46px 6px 46px;
  /* background: linear-gradient(135deg,
      #FFD700 0%,
      #FFD700 25%,
      #8B5CF6 75%,
      #8B5CF6 100%); */
  /* min-height: 378px; */
  min-height: 580px;
  width: 330px;
}

.slide-card-carousel {
  display: flex;
  justify-content: center;
  align-items: center;
}

.slide-card-carousel video {
  display: block;
  width: 100%;
  border-radius: 6px 46px 6px 46px !important;
  background: linear-gradient(135deg,
      #FFD700 0%,
      #FFD700 25%,
      #8B5CF6 75%,
      #8B5CF6 100%);
  padding: 2px;
  /* border: 2px solid #8B5CF6; */
  min-height: 580px;
  width: 330px;
}

.info-card:hover::before {
  background: linear-gradient(135deg, #FFD700 0%, #FFD700 25%, #8B5CF6 75%, #8B5CF6 100%);
  z-index: -2;
}

.info-card:hover::after {
  background: #FFFFFF;
  z-index: -1;
}

.card-icon {
  margin-bottom: 25px;
}

.card-title {
  font-family: var(--font-codec-cold);
  font-size: var(--font-size-large);
  font-weight: var(--font-bold);
  color: var(--text-gray);
}

.card-description {
  font-size: var(--font-size-regular);
  font-weight: var(--font-medium);
  color: var(--text-gray-dark);
  margin-top: 15px;
}

/* Background gradient for the section */
.bg-linear-gradient {
  background: linear-gradient(135deg, #F3E8FF 0%, #E9D5FF 100%);
  padding: 80px 0;
}

.slide-cards-container {
  padding-top: 20px;
}

/* Slide Card Carousel Styles */
.slide-card-carousel {
  position: relative;
  transition: opacity 0.5s ease-in-out;
}

.slide-card-carousel.fade-in {
  opacity: 1;
}

.slide-card-carousel.fade-out {
  opacity: 0;
}

.slide-card img {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 10px;
}

.slide-card-content {
  padding: 20px 65px;
}

.slide-card-content h4 {
  font-size: var(--font-size-xxlarge);
  font-weight: var(--font-semibold);
  margin-bottom: 20px;
  color: var(--text-black);
  margin-bottom: 30px;
}

.bg-image-1,
.bg-image-2 {
  position: relative;
}

.bg-image-1::before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  position: absolute;
  left: 0;
  top: 0;
}

.bg-image-2::before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  position: absolute;
  right: 0;
  top: 0;
}

.g-top-150 {
  padding-top: 150px;
}

.g-top-100 {
  padding-top: 100px;
}

.g-top-60 {
  padding-top: 60px;
}

.testimonial-card-content {
  padding: 80px 20px 50px 20px;
  position: relative;
}

.testimonial-card-content p {
  font-size: var(--font-size-xlarge);
  font-weight: var(--font-medium);
  color: var(--text-gray-light);
  margin-bottom: 20px;
}

.testimonial-card-content h3 {
  font-family: var(--font-codec-cold);
  font-size: var(--font-size-xxlarge);
  font-weight: var(--font-bold);
  color: var(--text-black);
}

.testimonial-card-content h4 {
  font-size: var(--font-size-large);
  font-weight: var(--font-medium);
  color: var(--text-black-light);
}

.testimonial-slider-container {
  padding: 50px 10px 80px 10px;
}

.testimonial-card-content::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 50px;
  height: 50px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.testimonial-card-content::after {
  content: '';
  position: absolute;
  bottom: 50px;
  right: 0;
  width: 50px;
  height: 50px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.section-list-items li {
  font-size: var(--font-size-medium);
  font-weight: var(--font-medium);
  color: var(--text-black);
  position: relative;
  padding: 5px 0 5px 30px !important;
}

.section-list-items li img {
  /* content: url('../../../../public/assets/img/website/check.svg');; */
  position: absolute;
  left: 0;
  top: 20px;
  transform: translateY(-40%);
  /* width: 30px; */
}

.section-container {
  background-color: var(--bg-white);
  padding: 60px 130px;
  border-radius: 12px;
  position: relative;
  box-shadow: 0 0 25px -5px rgba(0, 0, 0, 0.1);
  margin-top: 60px;
  background-clip: padding-box;
}

.section-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, var(--primary-color) 0%, var(--secondary-color) 100%);
  border-radius: 12px 12px 0 0;
}

.font-large {
  font-size: var(--font-size-large) !important;
}

.placeholder-section {
  padding-bottom: 40px;
}

/* .placeholder-section::before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 130px;
  background: linear-gradient(270deg, rgba(242, 204, 0, 0.4) 0%, rgba(99, 24, 198, 0.4) 100%);
} */

.pricing-card-2-heading span img {
  margin: 10px 10px 10px 10px;
  position: relative;
  top: -23px;
}

/* --- New Pricing Section Layout --- */
.pricing-section-new {
  background-color: #f6f2fb;
  padding: 56px 0px 80px 0px;
}

.seciton-pricing {
  padding: 0 35px;
}

/* Left Column: How it works */
.how-it-works-title {
  font-family: var(--font-codec-cold);
  font-size: 20px;
  font-weight: 700;
  color: #1C1528;
  margin-bottom: 15px;
}

.how-it-works-card {
  background-color: #ffffff;
  border-radius: 16px;
  padding: 25px 24px;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.03);
  transition: transform 0.2s;
}

.how-it-works-card:hover {
  transform: translateY(-2px);
}

.how-it-works-card-icon {
  width: 44px;
  height: 44px;
  margin-right: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}

.how-it-works-card-content {
  flex-grow: 1;
}

.how-it-works-card-content h5 {
  font-family: var(--font-montserrat, 'Montserrat', sans-serif);
  font-size: 15px;
  font-weight: 600;
  color: #1C1528;
  margin: 0 0 4px 0;
}

.how-it-works-card-content p {
  font-family: var(--font-montserrat, 'Montserrat', sans-serif);
  font-size: 14px;
  font-weight: 400;
  color: #6F677E;
  margin: 0;
}

/* Right Column: Pricing Card */
.pro-card-container {
  padding-left: 20px;
}

.pro-card-border-wrap {
  position: relative;
  border-radius: 24px;
  background: linear-gradient(135deg, #6318C6 0%, #F2CC00 100%);
  padding: 2px;
  height: 100%;
  box-shadow: 0px 8px 30px 0px rgba(0, 0, 0, 0.12);
}

.pro-card-inner {
  background-color: #ffffff;
  border-radius: 24px;
  padding: 30px 30px;
  position: relative;
  overflow: hidden;
  height: 100%;
}

.pro-card-content-z {
  position: relative;
  z-index: 2;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.unlock-more-badge {
  background-color: #6318C6;
  color: #ffffff;
  font-family: var(--font-montserrat, 'Montserrat', sans-serif);
  font-size: 12px;
  font-weight: 600;
  height: 23px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  padding: 0 16px;
  border-radius: 9999px;
  margin-bottom: 25px;
  align-self: flex-start;
}

.pro-card-title {
  font-family: var(--font-codec-cold);
  font-size: 24px;
  font-weight: 700;
  color: #060606;
  line-height: 1.3;
  margin-bottom: 20px;
}

.pro-list-item {
  background: linear-gradient(90deg, rgba(99, 24, 198, 0.1) 0%, rgba(242, 204, 0, 0.1) 100%);
  border-radius: 12px;
  padding: 12px 20px;
  display: flex;
  align-items: center;
  margin-bottom: 14px;
}

.pro-list-icon {
  margin-right: 16px;
  display: flex;
  width: 20px;
  justify-content: center;
}

.pro-list-text {
  font-size: 14px;
  font-weight: 500;
  color: #060606;
  margin: 0;
  font-family: var(--font-montserrat-medium);
}

.pro-bottom-box {
  background: linear-gradient(180deg, rgba(99, 24, 198, 0.1) 0%, rgba(242, 204, 0, 0.1) 100%);
  border-radius: 12px;
  margin-top: auto;
  padding: 20px 25px;
  margin-top: 25px;
  font-family: var(--font-montserrat-semibold);
}

.pro-bottom-text {
  font-family: var(--font-codec-cold);
  font-size: 18px;
  color: #060606;
  line-height: 1.5;
  margin-bottom: 24px;
  font-weight: 600;
}

.pro-bottom-text span {
  font-weight: 800;
}

.btn-explore-pricing {
  background: linear-gradient(90deg, #6318C6 0%, #a44893 50%, #e2b31c 100%);
  color: #ffffff;
  font-weight: 600;
  font-size: 16px;
  border: none;
  border-radius: 30px;
  padding: 9px 26px;
  display: inline-block;
  box-shadow: 0 8px 20px rgba(99, 24, 198, 0.2);
  transition: all 0.3s ease;
  cursor: pointer;
  text-decoration: none;
}

.btn-explore-pricing:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 25px rgba(99, 24, 198, 0.3);
  color: #ffffff;
}

@media (max-width: 991px) {
  .pro-card-container {
    padding-left: 15px;
    margin-top: 40px;
  }
}

@media (min-width: 768px) {
  .carousel {
    position: relative;
    padding: 10px 185px;
  }

  .header-gradient {
    min-height: 800px;
  }
}

@media (min-width: 1025px) and (max-width: 1280px) {
  .carousel-section h2 {
    font-size: 50px;
  }

  .font-heading {
    font-size: var(--font-size-40) !important;
    line-height: 1.2 !important;
  }

  .header-image-anim img {
    width: 450px;
  }

  .header-image-anim {
    right: 168px;
  }

  .sparkle-image {
    right: 109px;
  }

  .section-content {
    padding: 40px 0px 0 0px;
  }

  .header-gradient {
    min-height: 650px;
  }

  .carousel-section p {
    font-size: var(--font-size-medium) !important;
  }

  .step-image img {
    max-width: 245px;
  }

  .step-image {
    min-height: 200px;
  }

  .step-info .step-number {
    font-size: var(--font-size-25) !important;
    font-weight: var(--font-semibold);
  }

  .step-info h4 {
    font-size: var(--font-size-25) !important;
    font-weight: var(--font-bold);
  }

  .step-info {
    padding: 0 35px;
  }

  .step-info p {
    font-size: var(--font-size-18) !important;
  }

  .card-title {
    font-size: var(--font-size-medium) !important;
  }

  .card-description {
    font-size: var(--font-size-xsmall) !important;
    color: var(--text-gray) !important;
  }

  .info-card {
    padding: 30px 40px 15px 40px;
  }

  .info-card::before {
    background: linear-gradient(135deg, #FFD700 0%, #FFD700 25%, #8B5CF6 75%, #8B5CF6 100%);
    z-index: -2;
  }

  .info-card::after {
    background: #FFFFFF;
    z-index: -1;
  }

  .testimonial-card-content p {
    font-size: var(--font-size-large) !important;
  }

  .testimonial-card-content h3 {
    font-size: var(--font-size-xlarge) !important;
  }

  .testimonial-card-content h4 {
    font-size: 22px !important;
  }

  .section-list-items li {
    font-size: 17px !important;
  }

  .section-list-items li img {
    top: 15px;
  }

  .font-large {
    font-size: 20px !important;
  }

  .footer-logo {
    width: 400px;
    height: fit-content;
  }

  .section-container {
    padding: 60px 130px 40px 130px;
  }
}

@media (min-width: 1281px) and (max-width: 1440px) {
  .carousel-section h2 {
    font-size: var(--font-size-xxxlarge);
  }

  .header-image-anim img {
    width: 400px;
  }

  .header-gradient {
    min-height: 800px;
  }
}

@media (min-width: 1441px) and (max-width: 1536px) {
  .carousel-section h2 {
    font-size: 58px;
  }

  .header-image-anim img {
    width: 450px;
  }

  .section-content {
    padding: 60px 0px 0 0px;
  }

  .header-gradient {
    min-height: 700px;
  }

  .section-container {
    padding: 60px 72px;
  }

  .header-image-anim {
    right: 200px;
  }

  .section-list-items li {
    font-size: var(--font-size-18) !important;
  }

  .section-list-items li img {
    top: 15px;
  }

  .font-large {
    font-size: var(--font-size-18) !important;
  }

  .font-heading {
    font-size: var(--font-size-xxxlarge) !important;
  }

  .navbar-brand img {
    width: 257px;
  }

  .step-image img {
    max-width: 292px;
  }

  .btn-primary,
  .navbar-expand-sm .navbar-nav.main-menu .nav-link {
    font-size: var(--font-size-xsmall) !important;
  }

  .step-info .step-number {
    font-size: var(--font-size-25);
  }

  .step-info h4 {
    font-size: var(--font-size-25);
  }

  .step-info p {
    font-size: var(--font-size-xsmall);
  }

  .login-lnk a {
    font-size: var(--font-size-18) !important;
  }

  .process-steps-container {
    padding: 0px 0 0 0 !important;
    background-position: center 35px !important;
  }

  .card-title {
    font-size: var(--font-size-25) !important;
    padding: 0 30px;
  }

  .card-description {
    font-size: var(--font-size-xsmall) !important;
  }

  .info-card {
    padding: 30px 35px 15px 35px;
  }

  .info-card::before {
    background: linear-gradient(135deg, #FFD700 0%, #FFD700 25%, #8B5CF6 75%, #8B5CF6 100%);
    z-index: -2;
  }

  .info-card::after {
    background: #FFFFFF;
    z-index: -1;
  }

  .slide-card-content h4 {
    font-size: var(--font-size-xlarge) !important;
    line-height: 1.3;
  }

  .testimonial-card-content p {
    font-size: var(--font-size-large) !important;
    ;
  }

  .testimonial-card-content h3 {
    font-size: var(--font-size-xlarge) !important;
    ;
  }

  .testimonial-card-content h4 {
    font-size: var(--font-size-medium) !important;
    ;
  }

  .pricing-details-content ul li {
    font-size: var(--font-size-25) !important;
    ;
  }
}


@media (min-width: 1537px) and (max-width: 1560px) {
  .header-image-anim img {
    width: 600px;
  }

  .header-image-anim {
    right: 160px;
  }

  .header-gradient {
    min-height: 800px;
  }
}

@media (min-width: 1600px) {
  .carousel-section h2 {
    font-size: 75px;
  }

  .header-gradient {
    min-height: 875px;
  }
}

@media (min-width: 480px) and (max-width: 575px) {
  .header-image-anim img {
    width: 242px !important;
  }

  .carousel-section h2 {
    font-size: var(--font-size-40) !important;
    margin-bottom: 11px;
  }

  .carousel-section p {
    font-size: var(--font-size-18) !important;
  }
}

/* Tablet devices - apply mobile layout */
@media (min-width: 768px) and (max-width: 1024px) {
  .carousel-section {
    padding: 160px 50px 0px 50px
  }

  .carousel-section h2 {
    font-size: var(--font-size-xxxlarge);
    margin-bottom: 11px;
  }

  .section-content {
    padding: 5px 0px 0 0px;
  }

  .carousel-section p {
    font-size: var(--font-size-medium);
  }

  .header-gradient {
    min-height: 59vh;
    border-radius: 0 0 35px 0;
  }

  .header-image-anim img {
    width: 278px;
  }

  .header-image-anim {
    position: absolute;
    bottom: 0;
    right: 20px;
  }

  .sparkle-image {
    left: 257px;
    bottom: 21px;
    right: inherit !important;
    top: inherit !important;
    width: 123px;
  }

  /* Navbar styling for tablet - same as mobile */
  .navbar-toggler-icon {
    width: 30px;
    height: 30px;
  }

  .step-info .step-number {
    font-size: var(--font-size-xsmall);
  }

  .step-info h4 {
    font-size: var(--font-size-xsmall);
  }

  .step-info {
    padding: 0 10px;
  }

  .step-info p {
    font-size: var(--font-size-small);
  }

  .step-image img {
    max-width: 75%;
  }

  .process-steps-container {
    background-position: center 73px;
  }

  .step-image {
    min-height: 140px;
  }

  .card-title {
    font-size: var(--font-size-regular);
  }

  .card-description {
    font-size: var(--font-size-xsmall);
  }

  .info-card {
    padding: 30px 20px 15px 20px;
  }

  .info-card::before {
    background: linear-gradient(135deg, #FFD700 0%, #FFD700 25%, #8B5CF6 75%, #8B5CF6 100%);
    z-index: -2;
  }

  .info-card::after {
    background: #FFFFFF;
    z-index: -1;
  }

  .info-cards-container {
    padding-top: 20px;
  }

  .slide-card-content h4 {
    font-size: var(--font-size-medium);
  }

  .testimonial-slider-container {
    padding: 50px 10px 80px 10px;
  }

  .carousel {
    position: relative;
    padding: 10px 115px;
  }

  .pricing-card-2 {
    padding: 35px 50px 30px 50px !important;
  }

  .pricing-card-2-heading {
    font-size: var(--font-size-lg);
  }


}

.list-item-2 {
  font-size: 18px !important;
  color: var(--text-black) !important;
}

.fon-heding-2 {
  font-size: var(--font-size-xxlarge);
  font-weight: var(--font-semibold);
  margin-bottom: 20px;
  color: var(--text-black);
  margin-bottom: 30px;
}

@media (max-width: 414px) {
  .font-head-2 {
    font-size: 15x !important;
  }

}

.bx-shadow {
  box-shadow: 0 0 25px -5px rgba(0, 0, 0, 0.3);
  border-radius: 30px;
  padding-bottom: 50px;
  padding-top: 35px;
}

@media (max-width: 767px) {
  .pricing-section-new {
    padding: 50px 0px 80px 0px;
  }

  .slide-card-carousel .video-wrapper {
    min-height: inherit !important;
    height: 540px !important;
    width: 312px !important;
  }

  .how-it-works-card-content p {
    font-size: 13px !important;
  }


  .how-it-works-card {
    margin-bottom: 11px !important;
  }


  .pro-list-text {
    font-size: 13px !important;
  }

  .pro-bottom-box {
    padding: 15px 20px !important;
    margin-top: 0px !important;
  }

  .pro-bottom-text {
    font-size: 14px !important;
    margin-bottom: 15px !important;
  }

  .btn-explore-pricing {
    font-size: 13px !important;
    padding: 9px 18px !important;
  }

  .pro-list-icon {
    margin-right: 14px !important;
    width: 36px !important;
  }

  .pro-card-container {
    padding-left: 0px !important;
    margin-top: 5px !important;
  }

  .pro-card-title {
    font-size: 17px !important;
    font-weight: 600 !important;
    margin-bottom: 15px !important;
  }

  .pro-card-inner {
    padding: 22px 20px !important;
  }

  .how-it-works-title {
    font-size: 17px !important;
  }

  .how-it-works-card-content h5 {
    font-size: 14px !important;
  }

  .how-it-works-card {
    padding: 15px 20px !important;
  }

  .seciton-pricing {
    padding: 0 24px !important;
  }

  .section-3 {
    margin-bottom: 20px !important;
  }

  .mb-p-5 {
    padding: 0 11px;
  }

  .mb-heading-text {
    margin-bottom: 25px;
  }

  .slide-card-carousel video {
    height: 100% !important;
    min-height: inherit !important;
  }

  .slide-card img {
    width: 86% !important;
  }

  .placeholder-section {
    padding-bottom: 40px !important;
  }

  .fon-heding-2 {
    font-size: var(--font-size-xsmall) !important;
  }


  .font-head-2 {
    font-size: var(--font-size-xxlarge) !important;
    font-weight: var(--font-semibold);
    margin-bottom: 20px;
    color: var(--text-black) !important;
    margin-bottom: 30px;
  }

  .testimonial-card img {
    width: 200px;
  }

  .list-item-2 {
    font-size: 14px !important;
    color: var(--text-black) !important;
  }

  .font-head-2 {
    font-size: 14px !important;
    margin-bottom: 5px !important;
  }

  .carousel-section {
    padding: 114px 15px 0px 15px;
  }

  .carousel-section h2 {
    font-size: var(--font-size-large);
    margin-bottom: 11px;
  }

  .section-content {
    padding: 5px 0px 0 0px;
  }

  .carousel-section p {
    font-size: var(--font-x-size-small);
  }

  .header-gradient {
    min-height: 71vh;
    border-radius: 0 0 35px 0;
  }

  .header-image-anim img {
    width: 170px;
  }

  .header-image-anim {
    position: absolute;
    bottom: 0;
    right: 20px;
  }

  .sparkle-image {
    left: 41px;
    bottom: 21px;
    right: inherit !important;
    top: inherit !important;
    width: 60px;
  }

  .navbar-toggler-icon {
    width: 30px;
    height: 30px;
  }

  .process-steps-container {
    padding: 0 0 0 0;
  }

  .step-image {
    min-height: 140px;
  }

  .step-info .step-number {
    font-size: var(--font-size-regular);
  }

  .step-info h4 {
    font-size: var(--font-size-regular);
  }

  .step-info p {
    font-size: var(--font-size-small);
  }

  .step-info {
    padding: 0 25px;
    margin-bottom: 40px;
  }

  .info-card {
    padding: 20px 25px 20px 25px;
  }

  .info-card::before {
    background: linear-gradient(135deg, #FFD700 0%, #FFD700 25%, #8B5CF6 75%, #8B5CF6 100%);
    z-index: -2;
  }

  .info-card::after {
    background: #FFFFFF;
    z-index: -1;
  }

  .card-icon {
    margin-bottom: 17px;
  }

  .card-title {
    font-size: var(--font-size-xsmall);
  }

  .card-description {
    font-size: var(--font-size-small);
    margin-top: 10px;
  }

  .info-cards-container {
    padding-top: 20px;
  }

  .slide-card-content {
    padding: 20px 20px;
  }

  .slide-card-content h4 {
    font-size: var(--font-size-xsmall);
    line-height: 1.3;
  }

  .bg-image-1::before {
    transform: scale(0.5);
    transform-origin: top left;
  }

  .bg-image-2::before {
    transform: scale(0.5);
    transform-origin: top right;
  }

  .g-top-100 {
    padding-top: 25px;
  }

  .testimonial-card-content p {
    font-size: var(--font-size-small);
    padding-top: 48px;
  }

  .blog-detail-body {
    padding: 23px 15px 40px 15px !important;
  }

  .testimonial-card-content h3 {
    font-size: var(--font-size-xsmall);
  }

  .testimonial-card-content h4 {
    font-size: var(--font-size-xsmall);
  }

  .testimonial-card-content::before {
    width: 20px;
    height: 20px;
    top: 50px;
  }

  .testimonial-card-content::after {
    width: 20px;
    height: 20px;
  }

  .testimonial-card-content {
    padding: 20px 20px 22px 20px;
    position: relative;
  }

  .section-container {
    padding: 30px 25px;
    margin-top: 14px;
  }

  .section-list-items li img {
    width: 17px !important;
  }

  .section-list-items li {
    font-size: var(--font-size-small);
  }

  .font-large {
    font-size: var(--font-size-regular) !important;
  }

  .testimonial-slider-container {
    padding: 50px 10px 60px 10px;
  }

  .pricing-features-list span,
  .pricing-features-list p {
    font-size: 12px !important;
  }

  .pricing-action-btn {
    padding: 0.5rem 0.5rem !important;
  }

}

/* 576px and below */
@media (max-width: 576px) {
  .carousel-section h2 {
    font-size: var(--font-size-30);
    margin-bottom: 11px;
    /* text-align: center; */
  }

  .carousel-section p {
    font-size: 15px;
    /* text-align: center; */
  }

  .sparkle-image {
    left: 41px;
    bottom: 21px;
    right: inherit !important;
    top: inherit !important;
    width: 60px;
  }

  .header-image-anim img {
    width: 170px;
  }

  .header-image-anim {
    position: absolute;
    bottom: 0;
    right: 20px;
  }

}

/* 414px and below */
@media (max-width: 414px) {
  .carousel-section h2 {
    font-size: var(--font-size-xlarge);
    margin-bottom: 11px;
  }

  .carousel-section p {
    font-size: var(--font-size-small);
  }

  .sparkle-image {
    left: 41px;
    bottom: 21px;
    right: inherit !important;
    top: inherit !important;
    width: 60px;
  }

  .header-image-anim img {
    width: 170px;
  }

  .header-image-anim {
    position: absolute;
    bottom: 0;
    right: 20px;
  }

}

/* 375px and below */
@media (max-width: 375px) {
  .carousel-section h2 {
    font-size: var(--font-size-large);
    margin-bottom: 11px;
  }

  .carousel-section p {
    font-size: var(--font-x-size-small);
  }

  .sparkle-image {
    left: 41px;
    bottom: 21px;
    right: inherit !important;
    top: inherit !important;
    width: 60px;
  }

  .header-image-anim img {
    width: 200px;
  }

  .header-image-anim {
    position: absolute;
    bottom: 0;
    right: 20px;
  }

}

/* 360px and below */
@media (max-width: 360px) {
  .carousel-section h2 {
    font-size: var(--font-size-large);
    margin-bottom: 11px;
  }

  .carousel-section p {
    font-size: var(--font-x-size-small);
  }

  .sparkle-image {
    left: 41px;
    bottom: 21px;
    right: inherit !important;
    top: inherit !important;
    width: 60px;
  }

  .header-image-anim img {
    width: 170px;
  }

  .header-image-anim {
    position: absolute;
    bottom: 0;
    right: 20px;
  }

}

.section-3 {
  margin-bottom: 55px !important;
}

.font-head-2 {
  font-size: var(--font-size-xlarge);
  font-weight: var(--font-bold);
  color: var(--text-primary);
  margin-bottom: 15px;
  font-family: var(--font-codec-cold);
  line-height: 1.3;
}

@media (min-width: 1441px) and (max-width: 1536px) {

  .btn-primary-web,
  .navbar-expand-sm .navbar-nav.main-menu .nav-link {
    font-size: var(--font-size-xsmall) !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Website/LandingPage/LandingPage.css"],"names":[],"mappings":"AAAA;EACE,kHAAkH;EAClH,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,wBAAwB;EACxB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;EACjC,+BAA+B;EAC/B,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,yDAAgF;EAChF,oBAAoB;EACpB,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,6BAA6B;EAC7B,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,6BAA6B;EAC7B,0BAA0B;EAC1B,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,+BAA+B;EAC/B,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA,sBAAsB;;AAEtB;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,yBAAyB;EACzB,gCAAgC;EAChC,6BAA6B;EAC7B,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,uFAAuF;EACvF,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,mBAAmB;EACnB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,gCAAgC;EAChC;;;;sBAIoB;EACpB,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,2CAA2C;EAC3C;;;;mBAIiB;EACjB,YAAY;EACZ,+BAA+B;EAC/B,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,uFAAuF;EACvF,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;EACjC,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,wCAAwC;AACxC;EACE,6DAA6D;EAC7D,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;EACjC,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,gDAAmE;EACnE,kBAAkB;EAClB,OAAO;EACP,MAAM;AACR;;AAEA;EACE,gDAAmE;EACnE,kBAAkB;EAClB,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,+BAA+B;EAC/B,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;EACnC,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;EACjC,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,yDAA6E;EAC7E,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,yDAA8E;EAC9E,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,+BAA+B;EAC/B,wBAAwB;EACxB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,sEAAsE;EACtE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,4CAA4C;EAC5C,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,wFAAwF;EACxF,4BAA4B;AAC9B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;;;;;;;GAQG;;AAEH;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,UAAU;AACZ;;AAEA,uCAAuC;AACvC;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA,8BAA8B;AAC9B;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,6DAA6D;EAC7D,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,6DAA6D;EAC7D,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,0FAA0F;EAC1F,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,0CAA0C;AAC5C;;AAEA;EACE,2FAA2F;EAC3F,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yEAAyE;EACzE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,6CAA6C;EAC7C,yBAAyB;EACzB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE;IACE,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,yCAAyC;IACzC,2BAA2B;EAC7B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,6CAA6C;EAC/C;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,yCAAyC;IACzC,iCAAiC;EACnC;;EAEA;IACE,yCAAyC;IACzC,6BAA6B;EAC/B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,6CAA6C;EAC/C;;EAEA;IACE,6CAA6C;IAC7C,kCAAkC;EACpC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,uFAAuF;IACvF,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,6CAA6C;EAC/C;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,oCAAoC;EACtC;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,+CAA+C;EACjD;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,6CAA6C;EAC/C;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,6BAA6B;IAC7B,2CAA2C;EAC7C;;EAEA;IACE,yCAAyC;IACzC,eAAe;EACjB;;EAEA;IACE,6CAA6C;EAC/C;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,uFAAuF;IACvF,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,6CAA6C;IAC7C,gBAAgB;EAClB;;EAEA;IACE,4CAA4C;;EAE9C;;EAEA;IACE,6CAA6C;;EAE/C;;EAEA;IACE,6CAA6C;;EAE/C;;EAEA;IACE,yCAAyC;;EAE3C;AACF;;;AAGA;EACE;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yCAAyC;IACzC,mBAAmB;EACrB;;EAEA;IACE,yCAAyC;EAC3C;AACF;;AAEA,yCAAyC;AACzC;EACE;IACE;EACF;;EAEA;IACE,oCAAoC;IACpC,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,uBAAuB;IACvB,YAAY;EACd;;EAEA,+CAA+C;EAC/C;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,uFAAuF;IACvF,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,8BAA8B;EAChC;;;AAGF;;AAEA;EACE,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;EACjC,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;;AAEF;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;IAC9B,wBAAwB;IACxB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;;EAGA;IACE,8BAA8B;EAChC;;;EAGA;IACE,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;IAC7B,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,sBAAsB;EACxB;;EAEA;IACE,4BAA4B;IAC5B,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,8BAA8B;EAChC;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,6CAA6C;EAC/C;;;EAGA;IACE,8CAA8C;IAC9C,iCAAiC;IACjC,mBAAmB;IACnB,mCAAmC;IACnC,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,0BAA0B;IAC1B,mCAAmC;EACrC;;EAEA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,iCAAiC;IACjC,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,uFAAuF;IACvF,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,iCAAiC;IACjC,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kCAAkC;IAClC,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;IACrB,0BAA0B;EAC5B;;EAEA;IACE,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iCAAiC;IACjC,iBAAiB;EACnB;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,4BAA4B;IAC5B,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,8CAA8C;EAChD;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,iCAAiC;EACnC;;AAEF;;AAEA,oBAAoB;AACpB;EACE;IACE,8BAA8B;IAC9B,mBAAmB;IACnB,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,wBAAwB;EAC1B;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;AAEF;;AAEA,oBAAoB;AACpB;EACE;IACE,kCAAkC;IAClC,mBAAmB;EACrB;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;AAEF;;AAEA,oBAAoB;AACpB;EACE;IACE,iCAAiC;IACjC,mBAAmB;EACrB;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;AAEF;;AAEA,oBAAoB;AACpB;EACE;IACE,iCAAiC;IACjC,mBAAmB;EACrB;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;AAEF;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,6BAA6B;EAC7B,0BAA0B;EAC1B,mBAAmB;EACnB,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;;EAEE;;IAEE,6CAA6C;EAC/C;AACF","sourcesContent":[".header-gradient {\n  background: linear-gradient(90deg, var(--primary-color) 0%, var(--primary-color) 25%, var(--secondary-color) 100%);\n  border-radius: 0 0 250px 0;\n}\n\n.landing-page {\n  background-color: var(--bg-white);\n}\n\n.carousel-section {\n  padding: 176px 70px 0px 100px;\n}\n\n.section-content {\n  padding: 100px 0px 0 0px;\n}\n\n.carousel-section h2 {\n  font-size: var(--font-size-xxxxlarge);\n  font-weight: var(--font-bold);\n  color: var(--text-white);\n  margin-bottom: 30px;\n  font-family: var(--font-codec-cold);\n}\n\n.carousel-section p {\n  font-size: var(--font-size-large);\n  font-weight: var(--font-medium);\n  color: var(--text-white);\n  margin-bottom: 30px;\n}\n\n.carousel-section p span {\n  color: var(--secondary-color);\n  font-style: italic;\n}\n\n.header-image-anim {\n  position: absolute;\n  bottom: 0;\n  right: 250px;\n}\n\n.header-image-anim img {\n  width: 600px;\n}\n\n/* Carousel Styles */\n.carousel-container {\n  position: relative;\n  transition: opacity 0.5s ease-in-out;\n}\n\n.carousel-container.fade-in {\n  opacity: 1;\n}\n\n.carousel-container.fade-out {\n  opacity: 0;\n}\n\n.carousel-image {\n  width: 600px;\n  display: block;\n}\n\n/* Carousel Indicators */\n.carousel-indicators {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.indicator {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background-color: rgba(255, 255, 255, 0.5);\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.indicator:hover {\n  background-color: rgba(255, 255, 255, 0.8);\n  transform: scale(1.2);\n}\n\n.indicator.active {\n  background-color: var(--secondary-color);\n  transform: scale(1.2);\n}\n\n.sparkle-image {\n  position: absolute;\n  right: 150px;\n  top: 200px\n}\n\n.process-steps-container {\n  padding: 0px 0 0 0;\n  background-image: url('../../../../public/assets/img/website/bg-curve-line.svg');\n  background-size: 50%;\n  background-position: center 20px;\n  background-repeat: no-repeat;\n}\n\n.step-image {\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.step-image img {\n  max-width: 275px;\n}\n\n.step-info .step-number {\n  font-size: var(--font-size-xlarge);\n  font-weight: var(--font-bold);\n  color: var(--text-black);\n  margin-bottom: 10px;\n}\n\n.step-image {\n  min-height: 245px;\n  display: flex;\n  justify-content: center;\n  align-items: end;\n}\n\n.step-info h4 {\n  font-size: var(--font-size-xlarge);\n  font-weight: var(--font-bold);\n  color: var(--text-primary);\n  font-family: var(--font-codec-cold);\n  margin-top: 10px;\n}\n\n.step-info p {\n  font-size: var(--font-size-medium);\n  font-weight: var(--font-medium);\n  color: var(--text-black);\n  margin-top: 15px;\n}\n\n.step-info {\n  padding: 0 50px;\n}\n\n/* Info Cards Styles */\n\n.info-card {\n  background: #FFFFFF;\n  padding: 30px 75px 15px 75px;\n  text-align: center;\n  height: 100%;\n  position: relative;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n  transition: all 0.3s ease;\n  border-radius: 50px 8px 50px 8px;\n  border: 2px solid transparent;\n  background-clip: padding-box;\n  isolation: isolate;\n}\n\n.info-card::before {\n  content: '';\n  position: absolute;\n  top: -2px;\n  left: -2px;\n  right: -2px;\n  bottom: -2px;\n  border-radius: 50px 8px 50px 8px;\n  background: linear-gradient(135deg, #FFD700 0%, #FFD700 25%, #8B5CF6 75%, #8B5CF6 100%);\n  z-index: -1;\n  pointer-events: none;\n}\n\n.info-card::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border-radius: 50px 8px 50px 8px;\n  background: #FFFFFF;\n  z-index: -1;\n  pointer-events: none;\n}\n\n.info-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);\n}\n\n.slide-card-carousel {\n  border-radius: 6px 46px 6px 46px;\n}\n\n.slide-card-carousel video {\n  border-radius: 6px 46px 6px 46px;\n}\n\n.slide-card-carousel .video-wrapper {\n  padding: 2px;\n  /* border thickness */\n  border-radius: 6px 46px 6px 46px;\n  /* background: linear-gradient(135deg,\n      #FFD700 0%,\n      #FFD700 25%,\n      #8B5CF6 75%,\n      #8B5CF6 100%); */\n  /* min-height: 378px; */\n  min-height: 580px;\n  width: 330px;\n}\n\n.slide-card-carousel {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.slide-card-carousel video {\n  display: block;\n  width: 100%;\n  border-radius: 6px 46px 6px 46px !important;\n  background: linear-gradient(135deg,\n      #FFD700 0%,\n      #FFD700 25%,\n      #8B5CF6 75%,\n      #8B5CF6 100%);\n  padding: 2px;\n  /* border: 2px solid #8B5CF6; */\n  min-height: 580px;\n  width: 330px;\n}\n\n.info-card:hover::before {\n  background: linear-gradient(135deg, #FFD700 0%, #FFD700 25%, #8B5CF6 75%, #8B5CF6 100%);\n  z-index: -2;\n}\n\n.info-card:hover::after {\n  background: #FFFFFF;\n  z-index: -1;\n}\n\n.card-icon {\n  margin-bottom: 25px;\n}\n\n.card-title {\n  font-family: var(--font-codec-cold);\n  font-size: var(--font-size-large);\n  font-weight: var(--font-bold);\n  color: var(--text-gray);\n}\n\n.card-description {\n  font-size: var(--font-size-regular);\n  font-weight: var(--font-medium);\n  color: var(--text-gray-dark);\n  margin-top: 15px;\n}\n\n/* Background gradient for the section */\n.bg-linear-gradient {\n  background: linear-gradient(135deg, #F3E8FF 0%, #E9D5FF 100%);\n  padding: 80px 0;\n}\n\n.slide-cards-container {\n  padding-top: 20px;\n}\n\n/* Slide Card Carousel Styles */\n.slide-card-carousel {\n  position: relative;\n  transition: opacity 0.5s ease-in-out;\n}\n\n.slide-card-carousel.fade-in {\n  opacity: 1;\n}\n\n.slide-card-carousel.fade-out {\n  opacity: 0;\n}\n\n.slide-card img {\n  width: 100%;\n  height: auto;\n  display: block;\n  border-radius: 10px;\n}\n\n.slide-card-content {\n  padding: 20px 65px;\n}\n\n.slide-card-content h4 {\n  font-size: var(--font-size-xxlarge);\n  font-weight: var(--font-semibold);\n  margin-bottom: 20px;\n  color: var(--text-black);\n  margin-bottom: 30px;\n}\n\n.bg-image-1,\n.bg-image-2 {\n  position: relative;\n}\n\n.bg-image-1::before {\n  content: url('../../../../public/assets/img/website/pattern-1.svg');\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n\n.bg-image-2::before {\n  content: url('../../../../public/assets/img/website/pattern-2.svg');\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.g-top-150 {\n  padding-top: 150px;\n}\n\n.g-top-100 {\n  padding-top: 100px;\n}\n\n.g-top-60 {\n  padding-top: 60px;\n}\n\n.testimonial-card-content {\n  padding: 80px 20px 50px 20px;\n  position: relative;\n}\n\n.testimonial-card-content p {\n  font-size: var(--font-size-xlarge);\n  font-weight: var(--font-medium);\n  color: var(--text-gray-light);\n  margin-bottom: 20px;\n}\n\n.testimonial-card-content h3 {\n  font-family: var(--font-codec-cold);\n  font-size: var(--font-size-xxlarge);\n  font-weight: var(--font-bold);\n  color: var(--text-black);\n}\n\n.testimonial-card-content h4 {\n  font-size: var(--font-size-large);\n  font-weight: var(--font-medium);\n  color: var(--text-black-light);\n}\n\n.testimonial-slider-container {\n  padding: 50px 10px 80px 10px;\n}\n\n.testimonial-card-content::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 50px;\n  height: 50px;\n  background-image: url('../../../../public/assets/img/website/left-quote.svg');\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.testimonial-card-content::after {\n  content: '';\n  position: absolute;\n  bottom: 50px;\n  right: 0;\n  width: 50px;\n  height: 50px;\n  background-image: url('../../../../public/assets/img/website/right-quote.svg');\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.section-list-items li {\n  font-size: var(--font-size-medium);\n  font-weight: var(--font-medium);\n  color: var(--text-black);\n  position: relative;\n  padding: 5px 0 5px 30px !important;\n}\n\n.section-list-items li img {\n  /* content: url('../../../../public/assets/img/website/check.svg');; */\n  position: absolute;\n  left: 0;\n  top: 20px;\n  transform: translateY(-40%);\n  /* width: 30px; */\n}\n\n.section-container {\n  background-color: var(--bg-white);\n  padding: 60px 130px;\n  border-radius: 12px;\n  position: relative;\n  box-shadow: 0 0 25px -5px rgba(0, 0, 0, 0.1);\n  margin-top: 60px;\n  background-clip: padding-box;\n}\n\n.section-container::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, var(--primary-color) 0%, var(--secondary-color) 100%);\n  border-radius: 12px 12px 0 0;\n}\n\n.font-large {\n  font-size: var(--font-size-large) !important;\n}\n\n.placeholder-section {\n  padding-bottom: 40px;\n}\n\n/* .placeholder-section::before {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 130px;\n  background: linear-gradient(270deg, rgba(242, 204, 0, 0.4) 0%, rgba(99, 24, 198, 0.4) 100%);\n} */\n\n.pricing-card-2-heading span img {\n  margin: 10px 10px 10px 10px;\n  position: relative;\n  top: -23px;\n}\n\n/* --- New Pricing Section Layout --- */\n.pricing-section-new {\n  background-color: #f6f2fb;\n  padding: 56px 0px 80px 0px;\n}\n\n.seciton-pricing {\n  padding: 0 35px;\n}\n\n/* Left Column: How it works */\n.how-it-works-title {\n  font-family: var(--font-codec-cold);\n  font-size: 20px;\n  font-weight: 700;\n  color: #1C1528;\n  margin-bottom: 15px;\n}\n\n.how-it-works-card {\n  background-color: #ffffff;\n  border-radius: 16px;\n  padding: 25px 24px;\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.03);\n  transition: transform 0.2s;\n}\n\n.how-it-works-card:hover {\n  transform: translateY(-2px);\n}\n\n.how-it-works-card-icon {\n  width: 44px;\n  height: 44px;\n  margin-right: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.how-it-works-card-content {\n  flex-grow: 1;\n}\n\n.how-it-works-card-content h5 {\n  font-family: var(--font-montserrat, 'Montserrat', sans-serif);\n  font-size: 15px;\n  font-weight: 600;\n  color: #1C1528;\n  margin: 0 0 4px 0;\n}\n\n.how-it-works-card-content p {\n  font-family: var(--font-montserrat, 'Montserrat', sans-serif);\n  font-size: 14px;\n  font-weight: 400;\n  color: #6F677E;\n  margin: 0;\n}\n\n/* Right Column: Pricing Card */\n.pro-card-container {\n  padding-left: 20px;\n}\n\n.pro-card-border-wrap {\n  position: relative;\n  border-radius: 24px;\n  background: linear-gradient(135deg, #6318C6 0%, #F2CC00 100%);\n  padding: 2px;\n  height: 100%;\n  box-shadow: 0px 8px 30px 0px rgba(0, 0, 0, 0.12);\n}\n\n.pro-card-inner {\n  background-color: #ffffff;\n  border-radius: 24px;\n  padding: 30px 30px;\n  position: relative;\n  overflow: hidden;\n  height: 100%;\n}\n\n.pro-card-content-z {\n  position: relative;\n  z-index: 2;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.unlock-more-badge {\n  background-color: #6318C6;\n  color: #ffffff;\n  font-family: var(--font-montserrat, 'Montserrat', sans-serif);\n  font-size: 12px;\n  font-weight: 600;\n  height: 23px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  text-transform: uppercase;\n  padding: 0 16px;\n  border-radius: 9999px;\n  margin-bottom: 25px;\n  align-self: flex-start;\n}\n\n.pro-card-title {\n  font-family: var(--font-codec-cold);\n  font-size: 24px;\n  font-weight: 700;\n  color: #060606;\n  line-height: 1.3;\n  margin-bottom: 20px;\n}\n\n.pro-list-item {\n  background: linear-gradient(90deg, rgba(99, 24, 198, 0.1) 0%, rgba(242, 204, 0, 0.1) 100%);\n  border-radius: 12px;\n  padding: 12px 20px;\n  display: flex;\n  align-items: center;\n  margin-bottom: 14px;\n}\n\n.pro-list-icon {\n  margin-right: 16px;\n  display: flex;\n  width: 20px;\n  justify-content: center;\n}\n\n.pro-list-text {\n  font-size: 14px;\n  font-weight: 500;\n  color: #060606;\n  margin: 0;\n  font-family: var(--font-montserrat-medium);\n}\n\n.pro-bottom-box {\n  background: linear-gradient(180deg, rgba(99, 24, 198, 0.1) 0%, rgba(242, 204, 0, 0.1) 100%);\n  border-radius: 12px;\n  margin-top: auto;\n  padding: 20px 25px;\n  margin-top: 25px;\n  font-family: var(--font-montserrat-semibold);\n}\n\n.pro-bottom-text {\n  font-family: var(--font-codec-cold);\n  font-size: 18px;\n  color: #060606;\n  line-height: 1.5;\n  margin-bottom: 24px;\n  font-weight: 600;\n}\n\n.pro-bottom-text span {\n  font-weight: 800;\n}\n\n.btn-explore-pricing {\n  background: linear-gradient(90deg, #6318C6 0%, #a44893 50%, #e2b31c 100%);\n  color: #ffffff;\n  font-weight: 600;\n  font-size: 16px;\n  border: none;\n  border-radius: 30px;\n  padding: 9px 26px;\n  display: inline-block;\n  box-shadow: 0 8px 20px rgba(99, 24, 198, 0.2);\n  transition: all 0.3s ease;\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.btn-explore-pricing:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 12px 25px rgba(99, 24, 198, 0.3);\n  color: #ffffff;\n}\n\n@media (max-width: 991px) {\n  .pro-card-container {\n    padding-left: 15px;\n    margin-top: 40px;\n  }\n}\n\n@media (min-width: 768px) {\n  .carousel {\n    position: relative;\n    padding: 10px 185px;\n  }\n\n  .header-gradient {\n    min-height: 800px;\n  }\n}\n\n@media (min-width: 1025px) and (max-width: 1280px) {\n  .carousel-section h2 {\n    font-size: 50px;\n  }\n\n  .font-heading {\n    font-size: var(--font-size-40) !important;\n    line-height: 1.2 !important;\n  }\n\n  .header-image-anim img {\n    width: 450px;\n  }\n\n  .header-image-anim {\n    right: 168px;\n  }\n\n  .sparkle-image {\n    right: 109px;\n  }\n\n  .section-content {\n    padding: 40px 0px 0 0px;\n  }\n\n  .header-gradient {\n    min-height: 650px;\n  }\n\n  .carousel-section p {\n    font-size: var(--font-size-medium) !important;\n  }\n\n  .step-image img {\n    max-width: 245px;\n  }\n\n  .step-image {\n    min-height: 200px;\n  }\n\n  .step-info .step-number {\n    font-size: var(--font-size-25) !important;\n    font-weight: var(--font-semibold);\n  }\n\n  .step-info h4 {\n    font-size: var(--font-size-25) !important;\n    font-weight: var(--font-bold);\n  }\n\n  .step-info {\n    padding: 0 35px;\n  }\n\n  .step-info p {\n    font-size: var(--font-size-18) !important;\n  }\n\n  .card-title {\n    font-size: var(--font-size-medium) !important;\n  }\n\n  .card-description {\n    font-size: var(--font-size-xsmall) !important;\n    color: var(--text-gray) !important;\n  }\n\n  .info-card {\n    padding: 30px 40px 15px 40px;\n  }\n\n  .info-card::before {\n    background: linear-gradient(135deg, #FFD700 0%, #FFD700 25%, #8B5CF6 75%, #8B5CF6 100%);\n    z-index: -2;\n  }\n\n  .info-card::after {\n    background: #FFFFFF;\n    z-index: -1;\n  }\n\n  .testimonial-card-content p {\n    font-size: var(--font-size-large) !important;\n  }\n\n  .testimonial-card-content h3 {\n    font-size: var(--font-size-xlarge) !important;\n  }\n\n  .testimonial-card-content h4 {\n    font-size: 22px !important;\n  }\n\n  .section-list-items li {\n    font-size: 17px !important;\n  }\n\n  .section-list-items li img {\n    top: 15px;\n  }\n\n  .font-large {\n    font-size: 20px !important;\n  }\n\n  .footer-logo {\n    width: 400px;\n    height: fit-content;\n  }\n\n  .section-container {\n    padding: 60px 130px 40px 130px;\n  }\n}\n\n@media (min-width: 1281px) and (max-width: 1440px) {\n  .carousel-section h2 {\n    font-size: var(--font-size-xxxlarge);\n  }\n\n  .header-image-anim img {\n    width: 400px;\n  }\n\n  .header-gradient {\n    min-height: 800px;\n  }\n}\n\n@media (min-width: 1441px) and (max-width: 1536px) {\n  .carousel-section h2 {\n    font-size: 58px;\n  }\n\n  .header-image-anim img {\n    width: 450px;\n  }\n\n  .section-content {\n    padding: 60px 0px 0 0px;\n  }\n\n  .header-gradient {\n    min-height: 700px;\n  }\n\n  .section-container {\n    padding: 60px 72px;\n  }\n\n  .header-image-anim {\n    right: 200px;\n  }\n\n  .section-list-items li {\n    font-size: var(--font-size-18) !important;\n  }\n\n  .section-list-items li img {\n    top: 15px;\n  }\n\n  .font-large {\n    font-size: var(--font-size-18) !important;\n  }\n\n  .font-heading {\n    font-size: var(--font-size-xxxlarge) !important;\n  }\n\n  .navbar-brand img {\n    width: 257px;\n  }\n\n  .step-image img {\n    max-width: 292px;\n  }\n\n  .btn-primary,\n  .navbar-expand-sm .navbar-nav.main-menu .nav-link {\n    font-size: var(--font-size-xsmall) !important;\n  }\n\n  .step-info .step-number {\n    font-size: var(--font-size-25);\n  }\n\n  .step-info h4 {\n    font-size: var(--font-size-25);\n  }\n\n  .step-info p {\n    font-size: var(--font-size-xsmall);\n  }\n\n  .login-lnk a {\n    font-size: var(--font-size-18) !important;\n  }\n\n  .process-steps-container {\n    padding: 0px 0 0 0 !important;\n    background-position: center 35px !important;\n  }\n\n  .card-title {\n    font-size: var(--font-size-25) !important;\n    padding: 0 30px;\n  }\n\n  .card-description {\n    font-size: var(--font-size-xsmall) !important;\n  }\n\n  .info-card {\n    padding: 30px 35px 15px 35px;\n  }\n\n  .info-card::before {\n    background: linear-gradient(135deg, #FFD700 0%, #FFD700 25%, #8B5CF6 75%, #8B5CF6 100%);\n    z-index: -2;\n  }\n\n  .info-card::after {\n    background: #FFFFFF;\n    z-index: -1;\n  }\n\n  .slide-card-content h4 {\n    font-size: var(--font-size-xlarge) !important;\n    line-height: 1.3;\n  }\n\n  .testimonial-card-content p {\n    font-size: var(--font-size-large) !important;\n    ;\n  }\n\n  .testimonial-card-content h3 {\n    font-size: var(--font-size-xlarge) !important;\n    ;\n  }\n\n  .testimonial-card-content h4 {\n    font-size: var(--font-size-medium) !important;\n    ;\n  }\n\n  .pricing-details-content ul li {\n    font-size: var(--font-size-25) !important;\n    ;\n  }\n}\n\n\n@media (min-width: 1537px) and (max-width: 1560px) {\n  .header-image-anim img {\n    width: 600px;\n  }\n\n  .header-image-anim {\n    right: 160px;\n  }\n\n  .header-gradient {\n    min-height: 800px;\n  }\n}\n\n@media (min-width: 1600px) {\n  .carousel-section h2 {\n    font-size: 75px;\n  }\n\n  .header-gradient {\n    min-height: 875px;\n  }\n}\n\n@media (min-width: 480px) and (max-width: 575px) {\n  .header-image-anim img {\n    width: 242px !important;\n  }\n\n  .carousel-section h2 {\n    font-size: var(--font-size-40) !important;\n    margin-bottom: 11px;\n  }\n\n  .carousel-section p {\n    font-size: var(--font-size-18) !important;\n  }\n}\n\n/* Tablet devices - apply mobile layout */\n@media (min-width: 768px) and (max-width: 1024px) {\n  .carousel-section {\n    padding: 160px 50px 0px 50px\n  }\n\n  .carousel-section h2 {\n    font-size: var(--font-size-xxxlarge);\n    margin-bottom: 11px;\n  }\n\n  .section-content {\n    padding: 5px 0px 0 0px;\n  }\n\n  .carousel-section p {\n    font-size: var(--font-size-medium);\n  }\n\n  .header-gradient {\n    min-height: 59vh;\n    border-radius: 0 0 35px 0;\n  }\n\n  .header-image-anim img {\n    width: 278px;\n  }\n\n  .header-image-anim {\n    position: absolute;\n    bottom: 0;\n    right: 20px;\n  }\n\n  .sparkle-image {\n    left: 257px;\n    bottom: 21px;\n    right: inherit !important;\n    top: inherit !important;\n    width: 123px;\n  }\n\n  /* Navbar styling for tablet - same as mobile */\n  .navbar-toggler-icon {\n    width: 30px;\n    height: 30px;\n  }\n\n  .step-info .step-number {\n    font-size: var(--font-size-xsmall);\n  }\n\n  .step-info h4 {\n    font-size: var(--font-size-xsmall);\n  }\n\n  .step-info {\n    padding: 0 10px;\n  }\n\n  .step-info p {\n    font-size: var(--font-size-small);\n  }\n\n  .step-image img {\n    max-width: 75%;\n  }\n\n  .process-steps-container {\n    background-position: center 73px;\n  }\n\n  .step-image {\n    min-height: 140px;\n  }\n\n  .card-title {\n    font-size: var(--font-size-regular);\n  }\n\n  .card-description {\n    font-size: var(--font-size-xsmall);\n  }\n\n  .info-card {\n    padding: 30px 20px 15px 20px;\n  }\n\n  .info-card::before {\n    background: linear-gradient(135deg, #FFD700 0%, #FFD700 25%, #8B5CF6 75%, #8B5CF6 100%);\n    z-index: -2;\n  }\n\n  .info-card::after {\n    background: #FFFFFF;\n    z-index: -1;\n  }\n\n  .info-cards-container {\n    padding-top: 20px;\n  }\n\n  .slide-card-content h4 {\n    font-size: var(--font-size-medium);\n  }\n\n  .testimonial-slider-container {\n    padding: 50px 10px 80px 10px;\n  }\n\n  .carousel {\n    position: relative;\n    padding: 10px 115px;\n  }\n\n  .pricing-card-2 {\n    padding: 35px 50px 30px 50px !important;\n  }\n\n  .pricing-card-2-heading {\n    font-size: var(--font-size-lg);\n  }\n\n\n}\n\n.list-item-2 {\n  font-size: 18px !important;\n  color: var(--text-black) !important;\n}\n\n.fon-heding-2 {\n  font-size: var(--font-size-xxlarge);\n  font-weight: var(--font-semibold);\n  margin-bottom: 20px;\n  color: var(--text-black);\n  margin-bottom: 30px;\n}\n\n@media (max-width: 414px) {\n  .font-head-2 {\n    font-size: 15x !important;\n  }\n\n}\n\n.bx-shadow {\n  box-shadow: 0 0 25px -5px rgba(0, 0, 0, 0.3);\n  border-radius: 30px;\n  padding-bottom: 50px;\n  padding-top: 35px;\n}\n\n@media (max-width: 767px) {\n  .pricing-section-new {\n    padding: 50px 0px 80px 0px;\n  }\n\n  .slide-card-carousel .video-wrapper {\n    min-height: inherit !important;\n    height: 540px !important;\n    width: 312px !important;\n  }\n\n  .how-it-works-card-content p {\n    font-size: 13px !important;\n  }\n\n\n  .how-it-works-card {\n    margin-bottom: 11px !important;\n  }\n\n\n  .pro-list-text {\n    font-size: 13px !important;\n  }\n\n  .pro-bottom-box {\n    padding: 15px 20px !important;\n    margin-top: 0px !important;\n  }\n\n  .pro-bottom-text {\n    font-size: 14px !important;\n    margin-bottom: 15px !important;\n  }\n\n  .btn-explore-pricing {\n    font-size: 13px !important;\n    padding: 9px 18px !important;\n  }\n\n  .pro-list-icon {\n    margin-right: 14px !important;\n    width: 36px !important;\n  }\n\n  .pro-card-container {\n    padding-left: 0px !important;\n    margin-top: 5px !important;\n  }\n\n  .pro-card-title {\n    font-size: 17px !important;\n    font-weight: 600 !important;\n    margin-bottom: 15px !important;\n  }\n\n  .pro-card-inner {\n    padding: 22px 20px !important;\n  }\n\n  .how-it-works-title {\n    font-size: 17px !important;\n  }\n\n  .how-it-works-card-content h5 {\n    font-size: 14px !important;\n  }\n\n  .how-it-works-card {\n    padding: 15px 20px !important;\n  }\n\n  .seciton-pricing {\n    padding: 0 24px !important;\n  }\n\n  .section-3 {\n    margin-bottom: 20px !important;\n  }\n\n  .mb-p-5 {\n    padding: 0 11px;\n  }\n\n  .mb-heading-text {\n    margin-bottom: 25px;\n  }\n\n  .slide-card-carousel video {\n    height: 100% !important;\n    min-height: inherit !important;\n  }\n\n  .slide-card img {\n    width: 86% !important;\n  }\n\n  .placeholder-section {\n    padding-bottom: 40px !important;\n  }\n\n  .fon-heding-2 {\n    font-size: var(--font-size-xsmall) !important;\n  }\n\n\n  .font-head-2 {\n    font-size: var(--font-size-xxlarge) !important;\n    font-weight: var(--font-semibold);\n    margin-bottom: 20px;\n    color: var(--text-black) !important;\n    margin-bottom: 30px;\n  }\n\n  .testimonial-card img {\n    width: 200px;\n  }\n\n  .list-item-2 {\n    font-size: 14px !important;\n    color: var(--text-black) !important;\n  }\n\n  .font-head-2 {\n    font-size: 14px !important;\n    margin-bottom: 5px !important;\n  }\n\n  .carousel-section {\n    padding: 114px 15px 0px 15px;\n  }\n\n  .carousel-section h2 {\n    font-size: var(--font-size-large);\n    margin-bottom: 11px;\n  }\n\n  .section-content {\n    padding: 5px 0px 0 0px;\n  }\n\n  .carousel-section p {\n    font-size: var(--font-x-size-small);\n  }\n\n  .header-gradient {\n    min-height: 71vh;\n    border-radius: 0 0 35px 0;\n  }\n\n  .header-image-anim img {\n    width: 170px;\n  }\n\n  .header-image-anim {\n    position: absolute;\n    bottom: 0;\n    right: 20px;\n  }\n\n  .sparkle-image {\n    left: 41px;\n    bottom: 21px;\n    right: inherit !important;\n    top: inherit !important;\n    width: 60px;\n  }\n\n  .navbar-toggler-icon {\n    width: 30px;\n    height: 30px;\n  }\n\n  .process-steps-container {\n    padding: 0 0 0 0;\n  }\n\n  .step-image {\n    min-height: 140px;\n  }\n\n  .step-info .step-number {\n    font-size: var(--font-size-regular);\n  }\n\n  .step-info h4 {\n    font-size: var(--font-size-regular);\n  }\n\n  .step-info p {\n    font-size: var(--font-size-small);\n  }\n\n  .step-info {\n    padding: 0 25px;\n    margin-bottom: 40px;\n  }\n\n  .info-card {\n    padding: 20px 25px 20px 25px;\n  }\n\n  .info-card::before {\n    background: linear-gradient(135deg, #FFD700 0%, #FFD700 25%, #8B5CF6 75%, #8B5CF6 100%);\n    z-index: -2;\n  }\n\n  .info-card::after {\n    background: #FFFFFF;\n    z-index: -1;\n  }\n\n  .card-icon {\n    margin-bottom: 17px;\n  }\n\n  .card-title {\n    font-size: var(--font-size-xsmall);\n  }\n\n  .card-description {\n    font-size: var(--font-size-small);\n    margin-top: 10px;\n  }\n\n  .info-cards-container {\n    padding-top: 20px;\n  }\n\n  .slide-card-content {\n    padding: 20px 20px;\n  }\n\n  .slide-card-content h4 {\n    font-size: var(--font-size-xsmall);\n    line-height: 1.3;\n  }\n\n  .bg-image-1::before {\n    transform: scale(0.5);\n    transform-origin: top left;\n  }\n\n  .bg-image-2::before {\n    transform: scale(0.5);\n    transform-origin: top right;\n  }\n\n  .g-top-100 {\n    padding-top: 25px;\n  }\n\n  .testimonial-card-content p {\n    font-size: var(--font-size-small);\n    padding-top: 48px;\n  }\n\n  .blog-detail-body {\n    padding: 23px 15px 40px 15px !important;\n  }\n\n  .testimonial-card-content h3 {\n    font-size: var(--font-size-xsmall);\n  }\n\n  .testimonial-card-content h4 {\n    font-size: var(--font-size-xsmall);\n  }\n\n  .testimonial-card-content::before {\n    width: 20px;\n    height: 20px;\n    top: 50px;\n  }\n\n  .testimonial-card-content::after {\n    width: 20px;\n    height: 20px;\n  }\n\n  .testimonial-card-content {\n    padding: 20px 20px 22px 20px;\n    position: relative;\n  }\n\n  .section-container {\n    padding: 30px 25px;\n    margin-top: 14px;\n  }\n\n  .section-list-items li img {\n    width: 17px !important;\n  }\n\n  .section-list-items li {\n    font-size: var(--font-size-small);\n  }\n\n  .font-large {\n    font-size: var(--font-size-regular) !important;\n  }\n\n  .testimonial-slider-container {\n    padding: 50px 10px 60px 10px;\n  }\n\n  .pricing-features-list span,\n  .pricing-features-list p {\n    font-size: 12px !important;\n  }\n\n  .pricing-action-btn {\n    padding: 0.5rem 0.5rem !important;\n  }\n\n}\n\n/* 576px and below */\n@media (max-width: 576px) {\n  .carousel-section h2 {\n    font-size: var(--font-size-30);\n    margin-bottom: 11px;\n    /* text-align: center; */\n  }\n\n  .carousel-section p {\n    font-size: 15px;\n    /* text-align: center; */\n  }\n\n  .sparkle-image {\n    left: 41px;\n    bottom: 21px;\n    right: inherit !important;\n    top: inherit !important;\n    width: 60px;\n  }\n\n  .header-image-anim img {\n    width: 170px;\n  }\n\n  .header-image-anim {\n    position: absolute;\n    bottom: 0;\n    right: 20px;\n  }\n\n}\n\n/* 414px and below */\n@media (max-width: 414px) {\n  .carousel-section h2 {\n    font-size: var(--font-size-xlarge);\n    margin-bottom: 11px;\n  }\n\n  .carousel-section p {\n    font-size: var(--font-size-small);\n  }\n\n  .sparkle-image {\n    left: 41px;\n    bottom: 21px;\n    right: inherit !important;\n    top: inherit !important;\n    width: 60px;\n  }\n\n  .header-image-anim img {\n    width: 170px;\n  }\n\n  .header-image-anim {\n    position: absolute;\n    bottom: 0;\n    right: 20px;\n  }\n\n}\n\n/* 375px and below */\n@media (max-width: 375px) {\n  .carousel-section h2 {\n    font-size: var(--font-size-large);\n    margin-bottom: 11px;\n  }\n\n  .carousel-section p {\n    font-size: var(--font-x-size-small);\n  }\n\n  .sparkle-image {\n    left: 41px;\n    bottom: 21px;\n    right: inherit !important;\n    top: inherit !important;\n    width: 60px;\n  }\n\n  .header-image-anim img {\n    width: 200px;\n  }\n\n  .header-image-anim {\n    position: absolute;\n    bottom: 0;\n    right: 20px;\n  }\n\n}\n\n/* 360px and below */\n@media (max-width: 360px) {\n  .carousel-section h2 {\n    font-size: var(--font-size-large);\n    margin-bottom: 11px;\n  }\n\n  .carousel-section p {\n    font-size: var(--font-x-size-small);\n  }\n\n  .sparkle-image {\n    left: 41px;\n    bottom: 21px;\n    right: inherit !important;\n    top: inherit !important;\n    width: 60px;\n  }\n\n  .header-image-anim img {\n    width: 170px;\n  }\n\n  .header-image-anim {\n    position: absolute;\n    bottom: 0;\n    right: 20px;\n  }\n\n}\n\n.section-3 {\n  margin-bottom: 55px !important;\n}\n\n.font-head-2 {\n  font-size: var(--font-size-xlarge);\n  font-weight: var(--font-bold);\n  color: var(--text-primary);\n  margin-bottom: 15px;\n  font-family: var(--font-codec-cold);\n  line-height: 1.3;\n}\n\n@media (min-width: 1441px) and (max-width: 1536px) {\n\n  .btn-primary-web,\n  .navbar-expand-sm .navbar-nav.main-menu .nav-link {\n    font-size: var(--font-size-xsmall) !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
